import api from "./api";
import { API_BASE_URL } from "../config/api";
import {
  DEFAULT_LANDING_PAGE_CONTENT,
  normalizeLandingPageContent,
} from "../data/landingPageCmsDefaults";

const API_URL = API_BASE_URL;

export async function getLandingPageContentPublic() {
  return getLandingPageContentPublicBySlug("home");
}

export async function getLandingPageContentPublicBySlug(slug = "home") {
  const safeSlug = String(slug || "home").trim().toLowerCase() || "home";
  const response = await fetch(`${API_URL}/api/public/landing-page/pages/${encodeURIComponent(safeSlug)}`, {
    method: "GET",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error("Landingpage content laden mislukt");
  }
  const payload = await response.json().catch(() => ({}));
  return normalizeLandingPageContent(payload?.content || DEFAULT_LANDING_PAGE_CONTENT);
}

export async function getLandingPageContentAdmin() {
  return getLandingPageContentAdminBySlug("home");
}

export async function listLandingPagesAdmin() {
  const res = await api.get("/admin/landing-page/pages");
  const pages = Array.isArray(res?.data?.pages) ? res.data.pages : [];
  return pages
    .map((item) => ({
      slug: String(item?.slug || "").trim().toLowerCase(),
      updatedAt: item?.updatedAt || null,
      updatedBy: item?.updatedBy || null,
    }))
    .filter((item) => item.slug);
}

export async function getLandingPageContentAdminBySlug(slug = "home") {
  const safeSlug = String(slug || "home").trim().toLowerCase() || "home";
  const res = await api.get(`/admin/landing-page/pages/${encodeURIComponent(safeSlug)}`);
  return {
    slug: String(res?.data?.slug || safeSlug),
    content: normalizeLandingPageContent(res?.data?.content || DEFAULT_LANDING_PAGE_CONTENT),
    meta: {
      updatedAt: res?.data?.meta?.updatedAt || null,
      updatedBy: res?.data?.meta?.updatedBy || null,
    },
  };
}

export async function updateLandingPageContentAdmin(content) {
  return updateLandingPageContentAdminBySlug("home", content);
}

export async function updateLandingPageContentAdminBySlug(slug = "home", content) {
  const safeSlug = String(slug || "home").trim().toLowerCase() || "home";
  const normalized = normalizeLandingPageContent(content);
  const res = await api.put(`/admin/landing-page/pages/${encodeURIComponent(safeSlug)}`, {
    content: normalized,
  });
  return {
    slug: String(res?.data?.slug || safeSlug),
    content: normalizeLandingPageContent(res?.data?.content || normalized),
    meta: {
      updatedAt: res?.data?.meta?.updatedAt || null,
      updatedBy: res?.data?.meta?.updatedBy || null,
    },
    message: String(res?.data?.message || "Landingpage-content opgeslagen"),
  };
}
